<template>
  <div class="setup-hub-sidebar position-fixed">
    <setup-hub-sidebar-header />
    <setup-hub-sidebar-content />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SetupHubSidebarHeader from "@/components/setup-hub/sidebar/SetupHubSidebarHeader.vue";
import SetupHubSidebarContent from "@/components/setup-hub/sidebar/SetupHubSidebarContent.vue";

export default defineComponent({
  components: { SetupHubSidebarHeader, SetupHubSidebarContent },
});
</script>

<style scoped lang="scss">
.setup-hub-sidebar {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
